// extracted by mini-css-extract-plugin
export var divider = "SectionDivider-module--divider--b8a34";